import { getAssetUrl } from 'utils/assets.ts';
import s from './Icon.module.scss';

export type LoadingState = 'FETCHED' | 'LOADING' | 'ERROR';

const FETCHED: LoadingState = 'FETCHED';
const LOADING: LoadingState = 'LOADING';
const ERROR: LoadingState = 'ERROR';

const loadingStates: Record<string, LoadingState> = {};

const useFetchSprite = (spriteUrl: string) => {
  const state = loadingStates[spriteUrl];

  const fetchSvg = async () => {
    try {
      if (state === FETCHED || state === LOADING) return;

      loadingStates[spriteUrl] = LOADING;

      // Fetch SVG
      const response = await fetch(spriteUrl);
      const svgText = await response.text();

      // Append SVG to body
      const div = document.createElement('div');
      div.innerHTML = svgText;
      const svgElement = div.firstElementChild;
      if (!(svgElement instanceof SVGElement)) {
        throw new Error('Invalid SVG');
      }
      svgElement.classList.add(s.sprite);
      document.body.appendChild(svgElement);

      loadingStates[spriteUrl] = FETCHED;
    } catch (error) {
      loadingStates[spriteUrl] = ERROR;
      console.warn('Error fetching SVG:', error);
    }
  };

  fetchSvg();
};

export type IconProps = {
  name: string;
  className?: string;
  width?: number;
  height?: number;
};

const Icon: React.FC<IconProps> = ({
  name,
  className,
  width = 24,
  height = 24,
}) => {
  // replace these paths with correct ones after deployment
  useFetchSprite(getAssetUrl('sprite.mono.svg'));
  useFetchSprite(getAssetUrl('sprite.color.svg'));

  return (
    <svg
      width={width}
      height={height}
      role="graphics-symbol"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className={className}
    >
      <use href={`#${name}`} />
    </svg>
  );
};

export default Icon;
